import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Col } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import ActiveParikamiCardBody from "./ActiveParikamiCardBody";
import axios from "axios";
import { ServerPath } from "../../../../Constant";

const ActiveParikami = () => {
    const [count, setCount] = useState("--");

    useEffect(() => {
        const fetchCount = async () => {
            try {
                const response = await axios.get(`${ServerPath}/users/active-count`);
                console.log('active users response', response.data);
                if (response.data.success) {
                    setCount(response.data.data.total.toLocaleString());
                }
            } catch (error) {
                console.error("Error fetching active parikamis count:", error);
            }
        };
        
        fetchCount();
    }, []);

    return (
        <Col md="6" lg="4" className="box-col-4">
            <Card className="visitor-card">
                <CardHeader>
                    <div className="d-flex justify-content-between">
                        <div className="flex-grow-1">
                            <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>Active Parikamavasi's
                                <i className="fa fa-circle"></i>
                            </P>
                            <H4>{count}</H4>
                        </div>
                    </div>
                </CardHeader>
                <ActiveParikamiCardBody />
            </Card>
        </Col>
    );
};

export default ActiveParikami;